import { SET_LANGUAGE_CHOICES, type SetLanguageChoice } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Field, Select } from "@sagot/ui";
import type { SetLanguageStep } from "../types";
import { StepChannelNotes } from "./channel-notes";
import { type FormProps } from "./webhook-form";

const F = "engage.workflows.fields";

/** Set language: the language the assistant and the server-written lines use from here on, or back to detecting it. */
export function LanguageForm({ step, disabled, onChange }: FormProps<SetLanguageStep>) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <Field label={t(`${F}.languageChoice`)} hint={t(`${F}.languageHint`)}>
        <Select value={step.language} disabled={disabled} onChange={(e) => { onChange({ ...step, language: e.target.value as SetLanguageChoice }); }}>
          {SET_LANGUAGE_CHOICES.map((choice) => <option key={choice} value={choice}>{t(`${F}.languages.${choice}`)}</option>)}
        </Select>
      </Field>
      <p className="rounded-md bg-surface-2 p-3 text-xs text-fg-muted">{t(`${F}.languageEffect`)}</p>
      <StepChannelNotes type="set_language" />
    </div>
  );
}
